import React, { useEffect, useRef, useState } from 'react';
import { ChevronDownIcon, MenuIcon, PhoneIcon, XIcon } from 'lucide-react';
import { IMAGES, LINKS, TOLL_FREE_DISPLAY, TOLL_FREE_HREF, TOLL_FREE_NUMERIC } from '../data/site';
const autoLinks: {
  label: string;
  href: string;
}[] = [{
  label: 'Auto Glass',
  href: LINKS.auto
}, {
  label: 'Windshield Replacement',
  href: LINKS.windshield
}, {
  label: 'Windshield Chip Repair',
  href: LINKS.chip
}, {
  label: 'ADAS Calibration',
  href: LINKS.adas
}, {
  label: 'Emergency Auto Glass',
  href: LINKS.emergencyAuto
}];
const mainLinks: {
  label: string;
  href: string;
}[] = [{
  label: 'Residential Glass',
  href: LINKS.residential
}, {
  label: 'Glass Shower Doors',
  href: LINKS.shower
}, {
  label: 'Commercial Glass',
  href: LINKS.commercial
}, {
  label: 'Resources',
  href: LINKS.resources
}];
export function Header() {
  const [autoOpen, setAutoOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileAutoOpen, setMobileAutoOpen] = useState(false);
  const autoWrapRef = useRef<HTMLDivElement>(null);
  const autoButtonRef = useRef<HTMLButtonElement>(null);
  const mobileButtonRef = useRef<HTMLButtonElement>(null);
  const mobilePanelRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!autoOpen) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setAutoOpen(false);
        autoButtonRef.current?.focus();
      }
    };
    const onClick = (e: MouseEvent) => {
      if (!autoWrapRef.current?.contains(e.target as Node)) setAutoOpen(false);
    };
    document.addEventListener('keydown', onKey);
    document.addEventListener('mousedown', onClick);
    return () => {
      document.removeEventListener('keydown', onKey);
      document.removeEventListener('mousedown', onClick);
    };
  }, [autoOpen]);
  useEffect(() => {
    if (!mobileOpen) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setMobileOpen(false);
        mobileButtonRef.current?.focus();
      }
    };
    document.addEventListener('keydown', onKey);
    const first = mobilePanelRef.current?.querySelector<HTMLElement>('a, button');
    first?.focus();
    return () => document.removeEventListener('keydown', onKey);
  }, [mobileOpen]);
  const closeMobile = () => {
    setMobileOpen(false);
    setMobileAutoOpen(false);
  };
  return <header className="sticky top-0 z-50 bg-white" data-id="element-91" data-mp="1mki7202zvsf3">
      <div className="bg-kosin-charcoal text-white" data-id="element-92" data-mp="18madm256398o">
        <div className="mx-auto flex max-w-shell items-center justify-between gap-4 px-[18px] py-2 text-[12px] sm:px-6 sm:text-[13px]" data-id="element-93" data-mp="1cooxmpkkof1j">
          <p className="max-w-[20rem] text-[13px] leading-snug sm:max-w-none" data-id="element-94" data-mp="ypxkb5djaxeg">
            Auto Glass, Windshield Replacement &amp; Commercial Glass in
            Southeast Michigan
          </p>
          <div className="flex items-center gap-6" data-id="element-95" data-mp="2t3yirp569ie0">
            <p className="hidden whitespace-nowrap text-white/75 md:block" data-id="element-96" data-mp="2t141g6hggdot">Howell • Ann Arbor • Novi</p>
            <a href={TOLL_FREE_HREF} aria-label={`Call toll free ${TOLL_FREE_NUMERIC}`} className="focus-light hidden items-center gap-2 whitespace-nowrap text-[14px] font-bold text-white xl:inline-flex" data-id="element-97" data-mp="meo5532a1bkw">
              <PhoneIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-98" data-mp="w60y5xzta7si" />
              {TOLL_FREE_DISPLAY}
              <span className="font-normal text-white/70" data-id="element-99" data-mp="rc6e2tganqsw">
                ({TOLL_FREE_NUMERIC})
              </span>
            </a>
          </div>
        </div>
      </div>

      <div className="border-b border-kosin-line" data-id="element-100" data-mp="1051dv7mzsuba">
        <div className="mx-auto flex max-w-shell items-center justify-between gap-3 px-[18px] py-3 sm:gap-6 sm:px-6 lg:py-4" data-id="element-101" data-mp="108feobg0cvgm">
          <a href="#top" className="shrink-0" aria-label="Kosin’s Glass home" onClick={closeMobile} data-id="element-102" data-mp="1a3pk795m7kz5">
            <img src={IMAGES.logo} alt="Kosin’s Glass" width={227} height={95} className="h-[50px] w-auto sm:h-[58px] lg:h-[70px]" data-id="element-103" data-mp="3gwt2cei6vnz0" />
          </a>

          <nav aria-label="Main" className="hidden xl:block" data-id="element-104" data-mp="27xi64tj4ku11">
            <ul className="flex items-center gap-5 whitespace-nowrap text-[14px] font-medium text-kosin-ink" data-id="element-105" data-mp="27vxcr78jrh4r">
              <li data-id="element-106" data-mp="2cv0fgl121b9k">
                <a className="hover:text-kosin-red transition-colors duration-150 ease-kosin" href="#top" data-id="element-107" data-mp="2gy6jrn4lwsde">
                  Home
                </a>
              </li>
              <li className="relative" ref={autoWrapRef} data-id="element-108" data-mp="1k62xyk4o3ihv">
                <button ref={autoButtonRef} type="button" className="flex items-center gap-1 hover:text-kosin-red transition-colors duration-150 ease-kosin" aria-expanded={autoOpen} aria-haspopup="true" onClick={() => setAutoOpen(v => !v)} data-id="element-109" data-mp="1p8btno8xcyno">
                  Auto Glass
                  <ChevronDownIcon className={`h-4 w-4 transition-transform duration-150 ease-kosin ${autoOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-110" data-mp="15i8430exb837" />
                </button>
                {autoOpen && <ul className="absolute left-0 top-full z-50 mt-3 w-[264px] border border-kosin-line bg-white py-2 shadow-[0_12px_28px_rgba(22,22,22,0.12)]" data-id="element-111" data-mp="oxr7pl9cpuzd">
                    {autoLinks.map(link => <li key={link.label} data-id="element-112" data-mp="f2h5oxiydnll">
                        <a href={link.href} className="block px-4 py-2.5 text-[14px] text-kosin-ink hover:bg-kosin-mist hover:text-kosin-red transition-colors duration-150 ease-kosin" onClick={() => setAutoOpen(false)} data-id="element-113" data-mp="aafz9s8gur3h">
                          {link.label}
                        </a>
                      </li>)}
                  </ul>}
              </li>
              {mainLinks.map(link => <li key={link.label} data-id="element-114" data-mp="3dsaqg4dqojo8">
                  <a href={link.href} className="hover:text-kosin-red transition-colors duration-150 ease-kosin" data-id="element-115" data-mp="3dvggblu6zpl0">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>

          <div className="flex items-center gap-3" data-id="element-116" data-mp="38w3loex2xe7v">
            <a href={TOLL_FREE_HREF} aria-label={`Call toll free ${TOLL_FREE_NUMERIC}`} className="hidden items-center gap-2 whitespace-nowrap text-kosin-charcoal hover:text-kosin-red transition-colors duration-150 ease-kosin sm:flex xl:hidden" data-id="element-117" data-mp="f8p1h6vkq28">
              <PhoneIcon className="h-4 w-4 shrink-0 text-kosin-red" aria-hidden="true" data-id="element-118" data-mp="3rrtna113o8l8" />
              <span className="leading-tight" data-id="element-119" data-mp="jctdin5q9mmb">
                <span className="block text-[16px] font-bold" data-id="element-120" data-mp="jayvbgluc8lx">
                  {TOLL_FREE_DISPLAY}
                </span>
                <span className="block text-[12px] text-kosin-body" data-id="element-121" data-mp="28txdah1t3jse">
                  {TOLL_FREE_NUMERIC}
                </span>
              </span>
            </a>
            <a href="#quote" className="hidden whitespace-nowrap rounded bg-kosin-red px-5 py-2.5 text-[15px] font-semibold text-white hover:bg-kosin-bright transition-colors duration-150 ease-kosin lg:inline-block" data-id="element-122" data-mp="23uu90ytnhhlh">
              Get A Free Quote
            </a>
            <a href={TOLL_FREE_HREF} aria-label={`Call toll free ${TOLL_FREE_NUMERIC}`} title={`Call ${TOLL_FREE_DISPLAY} (${TOLL_FREE_NUMERIC})`} className="flex min-h-11 flex-col justify-center whitespace-nowrap text-kosin-red sm:hidden" data-id="element-123" data-mp="1pxfdrdgpufll">
              <span className="text-[12px] font-bold" data-id="element-124" data-mp="1uws9knpkex0b">{TOLL_FREE_DISPLAY}</span>
              <span className="text-[11px] text-kosin-body" data-id="element-125" data-mp="3a9d1pnxlilan">{TOLL_FREE_NUMERIC}</span>
            </a>
            <button ref={mobileButtonRef} type="button" className="flex h-11 w-11 items-center justify-center rounded border border-kosin-line text-kosin-charcoal xl:hidden" aria-label={mobileOpen ? 'Close menu' : 'Open menu'} title={mobileOpen ? 'Close menu' : 'Open menu'} aria-expanded={mobileOpen} aria-controls="mobile-menu" onClick={() => mobileOpen ? closeMobile() : setMobileOpen(true)} data-id="element-126" data-mp="369bak8phla9m">
              {mobileOpen ? <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-127" data-mp="1rbp31res0tqw" /> : <MenuIcon className="h-5 w-5" aria-hidden="true" data-id="element-128" data-mp="1wbur6xlu7y48" />}
            </button>
          </div>
        </div>
      </div>

      {mobileOpen && <div id="mobile-menu" ref={mobilePanelRef} className="max-h-[calc(100dvh-160px)] overflow-y-auto overscroll-contain border-b border-kosin-line bg-white xl:hidden" data-id="element-129" data-mp="218ld41kbpnxk">
          <nav aria-label="Mobile" className="mx-auto max-w-shell px-[18px] py-4 sm:px-6" data-id="element-130" data-mp="2k6wodb94hh3t">
            <ul className="divide-y divide-kosin-line text-[16px] font-medium text-kosin-ink" data-id="element-131" data-mp="2k8rc0xbs3nbl">
              <li data-id="element-132" data-mp="2fedb6fecknzj">
                <a href="#top" className="block py-3" onClick={closeMobile} data-id="element-133" data-mp="2becyaz6wckul">
                  Home
                </a>
              </li>
              <li data-id="element-134" data-mp="26gt8d20u6jmt">
                <button type="button" className="flex w-full items-center justify-between py-3" aria-expanded={mobileAutoOpen} onClick={() => setMobileAutoOpen(v => !v)} data-id="element-135" data-mp="26hcr2kyb9c1w">
                  Auto Glass
                  <ChevronDownIcon className={`h-4 w-4 transition-transform duration-150 ease-kosin ${mobileAutoOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-136" data-mp="2u3j9m15d2a6d" />
                </button>
                {mobileAutoOpen && <ul className="pb-3 pl-3" data-id="element-137" data-mp="1dt75jvzfnj10">
                    {autoLinks.map(link => <li key={link.label} data-id="element-138" data-mp="1d0tfj7k2rtfu">
                        <a href={link.href} className="block py-2 text-[15px] font-normal text-kosin-body" onClick={closeMobile} data-id="element-139" data-mp="184m5p3ok5xsm">
                          {link.label}
                        </a>
                      </li>)}
                  </ul>}
              </li>
              {mainLinks.map(link => <li key={link.label} data-id="element-140" data-mp="1qwezh0bgbn1e">
                  <a href={link.href} className="block py-3" onClick={closeMobile} data-id="element-141" data-mp="25s4prano6mbx">
                    {link.label}
                  </a>
                </li>)}
            </ul>
            <div className="mt-4 flex flex-col gap-2" data-id="element-142" data-mp="bdaf3aeb0jmu">
              <a href="#quote" className="rounded bg-kosin-red px-5 py-3 text-center text-[15px] font-semibold text-white" onClick={closeMobile} data-id="element-143" data-mp="bdu04zz93o53">
                Get A Free Quote
              </a>
              <a href={TOLL_FREE_HREF} aria-label={`Call toll free ${TOLL_FREE_NUMERIC}`} className="flex items-center justify-center gap-2 rounded border border-kosin-line px-5 py-3 text-kosin-charcoal" onClick={closeMobile} data-id="element-144" data-mp="2n16wp0zhgzm8">
                <PhoneIcon className="h-4 w-4 shrink-0 text-kosin-red" aria-hidden="true" data-id="element-145" data-mp="1za9w2kd51oqa" />
                <span className="text-[15px] font-bold" data-id="element-146" data-mp="23d6jqphjcb13">
                  Call {TOLL_FREE_DISPLAY}
                </span>
                <span className="text-[13px] text-kosin-body" data-id="element-147" data-mp="1pegkb378tz9k">
                  ({TOLL_FREE_NUMERIC})
                </span>
              </a>
            </div>
          </nav>
        </div>}
    </header>;
}